import { useTranslation } from "@/hooks/useTranslation";
import { Button } from "@/components/ui/button";
import { Globe, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const CompactLanguageToggle = () => {
  const { language, setLanguage, languageOptions } = useTranslation();

  const current = languageOptions.find((l) => l.code === language);
  const triggerLabel = current?.nativeName ?? language.toUpperCase();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="bg-background/80 backdrop-blur-sm border-primary/20 hover:bg-background/90"
        >
          <Globe className="h-4 w-4 mr-1.5" />
          {triggerLabel}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[120px] bg-background">
        {languageOptions.map((opt) => (
          <DropdownMenuItem
            key={opt.code}
            onClick={() => setLanguage(opt.code)}
            className="cursor-pointer"
          >
            <span className="flex items-center justify-between w-full">
              <span>{opt.nativeName}</span>
              {language === opt.code && <Check className="h-4 w-4 ml-2" />}
            </span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
